
import Vue from "vue";
import msDataProvider from "@/services/msDataProvider";

export default Vue.extend({
  props: ['value'],
  data() {
    return {
      dialog: false,
      emails: [],
      phones: [],
      helpCenterOptions: {}
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.init();
      }
    },
    dialog: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      this.helpCenterOptions = {
        title: this.$t('OPTIONS.CONTACT_AND_SUPPORT'),
        cancel: this.$t('APP.CLOSE')
      };
      const res: any = await msDataProvider.getData("clientSetting");
      if (res && res.settings && res.settings.contact_admins) {
        const contactAdmins = res.settings.contact_admins;
        this.emails = contactAdmins.map(admin => admin.email) || [];
        this.phones = contactAdmins.map(admin => admin.phone_number) || [];
      } else if (res  && res.settings && res.settings.contact_admin) {
        const contactAdmin = res.settings.contact_admin;
        if (Array.isArray(contactAdmin.email)) {
          this.emails = contactAdmin.email
        }

        if (Array.isArray(contactAdmin.phone_number)) {
          this.phones = contactAdmin.phone_number
        }
      } else {
        this.emails = [];
        this.phones = [];
      }
    },
    close() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
    async goToHelpCenter() {
      const baseUrl = 'https://localhost:40001/ui'
      const url = '/user-guide/index'
      const authenToken = sessionStorage.getItem('authenToken') || ""
      const serverName = localStorage.getItem('serverName') || sessionStorage.getItem('serverName') || ""
      let authorizedToken = ''
      if (authenToken) {
        authorizedToken = `authorized_token=${authenToken}`
      }
      try {
        await msDataProvider.executeCommand(
            "extOpenUrl",
            {url: baseUrl + url + '?' + authorizedToken + '&' + 'serverName=' + serverName}
        );
      } catch (e) {
        console.log(e);
      }
    },
    async goToTroubleShooting() {
      const baseUrl = "https://localhost:40001/ui";
      const url = "/user-guide/index?#iii-h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-kh%E1%BA%AFc-ph%E1%BB%A5c-l%E1%BB%97i";
      try {
        await msDataProvider.executeCommand("extOpenUrl", {
          url: baseUrl + url,
        });
      } catch (e) {
        console.log(e);
      }
    }
  }
});
